import { render, staticRenderFns } from "./Template-1.vue?vue&type=template&id=36f6399a&scoped=true"
import script from "./Template-1.vue?vue&type=script&lang=js"
export * from "./Template-1.vue?vue&type=script&lang=js"
import style0 from "./Template-1.vue?vue&type=style&index=0&id=36f6399a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6399a",
  null
  
)

export default component.exports